<template>
  <div class="dizme_tm_section" id="home">
    <div class="dizme_tm_hero">
      <div
        class="background"
        :data-img-url="`/img/slider/${dark ? 2 : 1}.jpg`"
      ></div>
      <div class="container">
        <div class="content">
          <div class="details">
            <div class="hello">
              <h3 class="orangeText">Hello, I'm</h3>
            </div>
            <div class="name">
              <h3>Brian Tarbox</h3>
            </div>
            <div class="job">
              <p>
                Experienced <span class="orangeText">Software Developer</span> and
                <span class="orangeText">AWS Expert</span>
              </p>
            </div>
            <div class="text">
              <p>
Software development has been my craft for four decades. Ten years ago, AWS became my focus, and that focus has grown into deep expertise: I now architect and implement cloud solutions at an expert level, recognized across the field.
              </p>
            </div>
            <div class="button">
              <div class="dizme_tm_button">
                <a class="anchor" href="#about"><span>About Me</span></a>
              </div>
              <div class="social">
                <ul>
                  <li>
                    <a href="#"><i class="icon-facebook-1"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="icon-twitter-1"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="icon-linkedin-1"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="icon-behance"></i></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="avatar">
            <div class="image">
              <!-- <img src="/img/slider/avatar.png" alt="" width="390px"
                height="390px" /> -->
              <img 
                class="profilePictureHero"
                src="/img/slider/profile.png" 
                alt=""
              />
              <img
                class="skills foo anim_moveBottom"
                src='/img/badges/aws-ambassador.png' alt=""/>
              <img
                class="skills illustrator anim_moveBottom"
                src='/img/badges/AlexaChampions.png' alt=""/>
              <img 
                class="skills photoshop anim_moveBottom" 
                src='/img/badges/AWSHeroes.png'/>
              <img 
                class="skills figma anim_moveBottom" 
                src='/img/badges/ClaudeArchEarlyAdopter.jpg'/>
            </div>
          </div>
        </div>
      </div>
      <div class="dizme_tm_down">
        <a class="anchor" href="#process" v-html="dark ? mouseDark : mouse">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { figma, mouse, mouseDark, ps } from "../svg";
export default {
  name: "HomeComponent",
  data() {
    return { 
      ps, figma, mouse, mouseDark,
      AlexaChampion: '/img/badges/AlexaChampions.png',
    };
  },
  props: {
    dark: { type: Boolean },
  },
};
</script>
